import { IFontFamily } from '../types';

export const fontFamily: IFontFamily = {
  primary: '"sofia_pro_bold", Helvetica, Arial, sans-serif',
  secondary: '"sofia_pro", Helvetica, Arial, sans-serif',
};
